<template>    
   
    <td class="text-center">
        <router-link :to="'/tanques/' + props.value.id">
            <span class="px-3 link-info"
                v-if="props.value.tag && props.value.tag.includes('SOMA')"><b>TANQUE SOMA</b></span>
            <span class="px-3 link-info" v-else><b>{{
                    props.value.name ? props.value.name.toUpperCase() : props.value.tag
                }}</b></span>
        </router-link>
    </td>
    <td class="text-center">
        {{ props.value.content }}
    </td>
    <td class="text-center">
        {{ floatToDecimal(props.value.currentVolume) }} / {{ floatToDecimal(props.value.capacity) }} {{ props.value.unit }}
    </td>
    <td class="text-center w-120">
        <CustomProgress :value="(props.value.currentVolume / props.value.capacity) * 100" :level="props.value.level" />
        <!-- <BProgress class="animated-progress custom-progress progress-label">
            <BProgress-bar :value="(props.value.current_volume / props.value.capacity) * 100" :variant="
                parseInt(props.value.level) > 0 ?
                        (props.value.level == 1 ? 'success' :
                            (
                                props.value.level == 2 ? 'warning' : 'danger'
                            ))
                    : 'info'
                ">
                <div class="label">{{ floatToDecimal((props.value.current_volume / props.value.capacity) * 100) }} %</div>
            </BProgress-bar>
        </BProgress> -->
    </td>
    <td class="text-center">
        <div :class="parseInt(props.value.level) > 0 ?
                        (props.value.level == 1 ? 'badge-success' :
                            (
                                props.value.level == 2 ? 'badge-warning' : 'badge-danger'
                            ))
                    : 'badge-info'" class="badge fs-12"
        >
            {{
                parseInt(props.value.level) > 0 ?
                    (props.value.level == 1 ? 'NORMAL' :
                        (
                            props.value.level == 2 ? 'RECARGA' : 'CRÍTICO'
                        ))
                    : 'INDEFINIDO'
            }}
        </div>
    </td>
    
    <td class="text-center">
        {{ props.value.updated }}
    </td>
</template>

<script setup>

// import {defineProps, defineEmits, computed} from 'vue';
import CustomProgress from "./CustomProgress.vue";
import {floatToDecimal} from "./Dependencies/functions";

const props = defineProps({
    value: {
        type: Object,
        required: true
    },
    isFavorite: {
        type: Boolean,
        required: true
    }
});

const emit = defineEmits(["removeFavorite", "addFavorite"]);

const favorite = (value) => {
    if (props.isFavorite) {
        emit('removeFavorite', value)
    } else {
        emit('addFavorite', value)
    }
}

// const compFavorite = computed(() => props.isFavorite)


</script>

<style scoped>

.w-120 {
    width: 120px!important;
}

.progress-label .progress-bar .label {
    right: -20px!important;
    z-index: 999!important;
}

.progress{
    height: 15px;
}

.label{
    color: black;
}

</style>
